import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, onMounted, ref } from 'vue';
import { getBetDetails } from '@/api/game';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import GameLogViewOne from '@/themes/themeOne/gameLog/gameLogView.vue';
import GameLogViewTwo from '@/themes/themeTwo/gameLog/gameLogView.vue';
import { BetRecord, GameLogData, PAGE_SIZE, TAB_LIST } from './supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'gameLogView',
  setup(__props) {

const themeStore = useThemeStore()
const loadingRef = ref()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')

const active = ref(0);
const total = ref(0)
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const tabList = ref(TAB_LIST)
const betList = ref<BetRecord[]>([])
const betTotal = ref(0)
const winLossAmount = ref(0)

const dataSet = computed<GameLogData>(() => ({
    active: active.value,
    total: total.value,
    pageSize: pageSize.value,
    pageNum: pageNum.value,
    tabList: tabList.value,
    betList: betList.value,
    betTotal: betTotal.value,
    winLossAmount: winLossAmount.value,
}))

const activeTimeGap = computed(() => tabList.value[active.value].time)

const onClickTab = (data: any) => {
    active.value = data.name
    total.value = 0
    pageNum.value = 1
    betList.value = []
    loadingRef.value.open()
    getGameLogDetails()
}
const getNextPageMsgList = () => {
    loadingRef.value.open()
    if (total.value > pageSize.value * pageNum.value) {
        pageNum.value = pageNum.value + 1
        getGameLogDetails()
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getGameLogDetails = () => {
    let data = {
        pageSize: pageSize.value,
        pageNum: pageNum.value,
        timeGap: activeTimeGap.value
    }
    getBetDetails(data).then(res => {
        loadingRef.value.close()
        total.value = res.data?.totalRecords
        betList.value = [...betList.value, ...res.data?.gameDetailList]
        betTotal.value = res.data?.betTotal
        winLossAmount.value = res.data?.totalResult
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}

onMounted(() => {
    loadingRef.value.open()
    getGameLogDetails()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(GameLogViewOne, {
            "data-set": dataSet.value,
            onGetNextPageMsgList: getNextPageMsgList,
            onOnClickTab: onClickTab
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(GameLogViewTwo, {
            "data-set": dataSet.value,
            onGetNextPageMsgList: getNextPageMsgList,
            onOnClickTab: onClickTab
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})